// Path constants for the VAISP operations module (`/api/admin/vasp/*`).
//
// Centralised so a backend prefix rename is a one-file edit
// (architecture-principles §7). Everything under this prefix is Ctrl-Alt
// *operational* surface — mirrored holdings and their documents, and the
// inbound webhook-event log — as distinct from the per-entity VAISP reads that
// live on the entity's own controller (`/api/admin/offerings/:id/vasp/listing`,
// `/api/admin/orders/:id/vasp-order`, `/api/vasp/investor-wallets`).
const VASP = '/api/admin/vasp'

export const VASP_ENDPOINT_PATHS = {
  /** Holdings mirrored from Ctrl-Alt. Requires an `offeringId` query param. */
  HOLDINGS: `${VASP}/holdings`,
  /**
   * Mints a short-lived presigned URL for one holding's fractional title deed.
   * A GET, but never cached — see the download mutation for why.
   */
  HOLDING_TITLE_DEED_DOWNLOAD_URL: (holdingId: string): string =>
    `${VASP}/holdings/${holdingId}/title-deed/download-url`,
  /** Re-fetch a holding's documents from Ctrl-Alt (POST). Bounded — see vaspDocumentRetry. */
  HOLDING_DOCUMENTS_RE_MIRROR: (holdingId: string): string =>
    `${VASP}/holdings/${holdingId}/documents/re-mirror`,
  /**
   * The whole inbound webhook-event log, filtered and paged (GET).
   * Newest first — the `/failed` sibling is the oldest-first replay queue.
   */
  WEBHOOK_EVENTS: `${VASP}/webhook-events`,
  /** Inbound webhook events that failed processing (GET). */
  WEBHOOK_EVENTS_FAILED: `${VASP}/webhook-events/failed`,
  /** Replay one failed event (POST). */
  WEBHOOK_EVENT_REPLAY: (id: string): string => `${VASP}/webhook-events/${id}/replay`,
  /** Replay a batch of failed events (POST). */
  WEBHOOK_EVENTS_REPLAY_FAILED: `${VASP}/webhook-events/replay-failed`,
} as const
